"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sleep = exports.isBetweenInterval = exports.getTTL = exports.subtractIntervals = exports.prepareDateTime = exports.toUtcTime = exports.isTodayOrFutureDate = exports.isNowOrPastDateTimeString = void 0;
const date_fns_1 = require("date-fns");
/**
 * Timezone agnostic check if input dateTimeString has current or past date time
 * @param {String} dateTimeString
 * @return {Boolean}
 */
function isNowOrPastDateTimeString(dateTimeString) {
    const dateTime = new Date(dateTimeString);
    const currentDateTime = new Date();
    if (!(0, date_fns_1.isDate)(dateTime)) {
        return false;
    }
    return toUtcTime(dateTime).getTime() <= toUtcTime(currentDateTime).getTime();
}
exports.isNowOrPastDateTimeString = isNowOrPastDateTimeString;
/**
 * Timezone agnostic check if input dateString has today's or future date
 * @param {Date} date
 * @return {Boolean}
 */
function isTodayOrFutureDate(date) {
    if (!(0, date_fns_1.isDate)(date)) {
        return false;
    }
    const dateInUtc = toUtcTime(date);
    return (0, date_fns_1.isToday)(dateInUtc) || (0, date_fns_1.isFuture)(dateInUtc);
}
exports.isTodayOrFutureDate = isTodayOrFutureDate;
function toUtcTime(dateTime) {
    const timezoneOffset = dateTime.getTimezoneOffset() * 60000;
    return new Date(dateTime.getTime() + timezoneOffset);
}
exports.toUtcTime = toUtcTime;
function prepareDateTime(date, time) {
    let dateTime = new Date(date);
    const hours = Math.trunc(time / 100);
    const minutes = time % 100;
    dateTime = (0, date_fns_1.addHours)(dateTime, hours);
    dateTime = (0, date_fns_1.addMinutes)(dateTime, minutes);
    return dateTime;
}
exports.prepareDateTime = prepareDateTime;
/**
 * Returns array of DateInterval entries as result of subtract of 2 intervals
 * @param {DateInterval} minuend
 * @param {DateInterval} subtrahend
 * @returns {DateInterval[]}
 */
function subtractIntervals(minuend, subtrahend) {
    if (!(0, date_fns_1.areIntervalsOverlapping)(minuend, subtrahend)) {
        return [minuend];
    }
    const isSubtrahendIntervalIncludesMinuend = minuend.start.getTime() >= subtrahend.start.getTime() && minuend.end.getTime() <= subtrahend.end.getTime();
    if (isSubtrahendIntervalIncludesMinuend) {
        return [];
    }
    const isSubtrahendIntervalOverlapsMinuendAtStart = minuend.start.getTime() >= subtrahend.start.getTime() && minuend.end.getTime() > subtrahend.end.getTime();
    if (isSubtrahendIntervalOverlapsMinuendAtStart) {
        return [{ start: subtrahend.end, end: minuend.end }];
    }
    const isSubtrahendIntervalOverlapsMinuendAtEnd = minuend.start.getTime() < subtrahend.start.getTime() && minuend.end.getTime() <= subtrahend.end.getTime();
    if (isSubtrahendIntervalOverlapsMinuendAtEnd) {
        return [{ start: minuend.start, end: subtrahend.start }];
    }
    return [
        { start: minuend.start, end: subtrahend.start },
        { start: subtrahend.end, end: minuend.end },
    ];
}
exports.subtractIntervals = subtractIntervals;
function getTTL(days) {
    return Math.round(Date.now() / 1000) + 60 * 60 * 24 * days;
}
exports.getTTL = getTTL;
function isBetweenInterval(start, end) {
    const now = new Date();
    return start && end && (0, date_fns_1.isWithinInterval)(now, { start: new Date(start), end: new Date(end) });
}
exports.isBetweenInterval = isBetweenInterval;
function sleep(ms) {
    // eslint-disable-next-line no-promise-executor-return
    return new Promise((resolve) => setTimeout(resolve, ms));
}
exports.sleep = sleep;
//# sourceMappingURL=index.js.map